// Circle community widget. The `mw` snippet in index.html only supports
// 'init'/'setDefaults'; the widget script exposes open/close on window.CircleWidget.
// https://green-check-user-community.circle.so/external/widget.js

declare global {
  interface Window {
    CircleWidget?: { open: (ev?: Event) => void; close: (ev?: Event) => void };
    openCircleCommunity?: () => void;
  }
}

export const openCircleCommunity = () => {
  if (!window.CircleWidget) {
    console.warn('Circle: widget script has not loaded, skipping open');
    return;
  }
  window.CircleWidget.open();
};

// Exposed on window so the Pendo Resource Center sandbox module can call it.
export const registerCircleCommunityLauncher = () => {
  window.openCircleCommunity = openCircleCommunity;
};
